import { showToast } from './toast-handler';

const severityMappings = {
    2: 'success',
};

const summaryMappings = {
    success: {
        200: 'Success',
        201: 'Created',
        204: 'No Content',
    },
};

function getSeverity(statusCode) {
    const firstDigit = Math.floor(statusCode / 100); // Extract the first digit of the status code
    return severityMappings[firstDigit] || 'info'; // Default to 'info' if not matched
}

function getResponseSummary(severity, statusCode) {
    return summaryMappings[severity]?.[statusCode] ?? 'Success';
}

class AppResponse {
    constructor(status, message) {
        this.severity = getSeverity(status);
        this.summary = getResponseSummary(this.severity, status);
        showToast({ severity: this.severity, summary: this.summary }, message);
    }
}

export default AppResponse;
